var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 1h7a2.75 2.75 0 0 1 2.75 2.75v7a2.75 2.75 0 0 1-2.75 2.75h-7A2.75 2.75 0 0 1 1 10.75v-7A2.75 2.75 0 0 1 3.75 1m10.555 4.114a.753.753 0 0 1 .977-.414A2.74 2.74 0 0 1 17 7.25v6.999a2.754 2.754 0 0 1-2.75 2.75h-7a2.74 2.74 0 0 1-2.55-1.718.751.751 0 0 1 1.39-.563c.193.475.648.782 1.16.782h7c.69 0 1.25-.561 1.25-1.25v-7c0-.512-.306-.967-.781-1.159a.75.75 0 0 1-.414-.977",
    clipRule: "evenodd"
  })));
};
export default SvgCopyIcon;